<div fxLayout="column" fxLayoutGap="10px">
	<rpshared-subdivision
		[formControl]="control"
		rpsharedRemoveHost
	></rpshared-subdivision>
	<div mat-dialog-actions>
		<button mat-button mat-dialog-close color="warn">
			Cancel
		</button>
		<button
			mat-button
			[disabled]="control.invalid"
			color="primary"
			[mat-dialog-close]="control"
		>
			Save
		</button>
	</div>
</div>
